<template>
  <base-modal-full ref="modal" title="Esai Peserta" :use-save="false">
    <v-card>
      <v-card-title class="secondary--text"> Kelengkapan Esai </v-card-title>
      <v-card-text class="px-7 black--text">
        <v-list-item class="px-0">
          <v-list-item-content class="py-0 mt-3">
            <div class="text-h6 primary--text">Info Peserta</div>
            <v-divider class="my-3" />
            <div class="my-3">
              <div class="label--text">Nama</div>
              <div class="body-1 font-weight-medium">{{
                $getDeepObj(info, 'akun.data.nama') || $getDeepObj(info, 'nama')
              }}</div>
            </div>
            <div class="mb-5">
              <div class="label--text">Email</div>
              <div class="body-1">{{ $getDeepObj(info, 'akun.data.email') || $getDeepObj(info, 'email') }}</div>
            </div>
            <div class="mb-5">
              <div class="label--text">Provinsi / Kota</div>
              <div class="body-1"
                >{{ $getDeepObj(info, 'akun.data.m_propinsi.data.keterangan') || $getDeepObj(info, 'propinsi') }} -
                {{ $getDeepObj(info, 'akun.data.m_kota.data.keterangan') || $getDeepObj(info, 'kota') }}</div
              >
            </div>
          </v-list-item-content>
        </v-list-item>
        <div class="text-h6 primary--text mb-2">Esai Peserta</div>
        <v-divider class="my-3" />

        <v-expansion-panels>
          <v-expansion-panel v-for="(item, i) in $getDeepObj(details, 'meta.materi') || []" :key="i">
            <v-expansion-panel-header>{{ item.keterangan }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(quest, q) in $getDeepObj(details, `meta.pertanyaans.${item.k_materi_esai_paud}`) || []"
                  :key="q"
                  class="blue-grey lighten-5"
                >
                  <v-expansion-panel-header>{{ q }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-expansion-panels>
                      <v-expansion-panel v-for="(child, c) in quest || []" :key="c">
                        <v-expansion-panel-header>
                          {{ child.pertanyaan }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="grey--text">
                            {{ getJawaban(child) }}
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </base-modal-full>
</template>
<script>
import BaseModalFull from '@components/base/BaseModalFull.vue';

export default {
  components: { BaseModalFull },
  data() {
    return {
      form: {},
      tab: [0],
      details: {},
      info: {},
    };
  },
  methods: {
    open(obj, info) {
      this.reset();
      this.$refs.modal.open();
      if (Object.keys(obj).length) {
        this.details = obj;
        this.info = info;
      }
    },
    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'details', {});
      this.$set(this, 'tab', []);
    },
    getJawaban(item) {
      const data = this.details.data || [];
      const find = data.find((obj) => obj.k_pertanyaan_esai_paud === item.k_pertanyaan_esai_paud) || {};
      if (Object.keys(find).length) {
        return find.draft || find.jawaban || 'Belum diisi';
      } else {
        return 'Belum diisi';
      }
    },
  },
};
</script>
